import { render, staticRenderFns } from "./DigivihotTable.vue?vue&type=template&id=6c5833ee"
import script from "./DigivihotTable.vue?vue&type=script&lang=js"
export * from "./DigivihotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports